import { useLoaderData } from '@remix-run/react';

type LoaderData<T> = {
  pageData: T;
};

export default function usePageData<T>() {
  const data = useLoaderData() as unknown as LoaderData<T>;

  return data.pageData;
}
